// Imperative confirm — `await confirmDialog({...})` returns true/false, so a
// native `if (!confirm('…')) return;` becomes `if (!await confirmDialog({…}))
// return;` with no local modal state. Renders through the existing <ConfirmDialog>
// component (see ConfirmHost in components/ConfirmDialog.jsx), mounted once at the
// app root. Before the host mounts (or in tests) it falls back to window.confirm.
//
//   call site ── confirmDialog(opts) ──▶ emit(req) ──▶ ConfirmHost renders modal
//        ▲                                                      │
//        └────────────── resolve(true|false) ◀─────────────────┘

let emit = null;

/** @param {{message:string, title?:string, confirmLabel?:string,
 *           cancelLabel?:string, kind?:'normal'|'danger'}} opts */
export function confirmDialog(opts) {
  const o = typeof opts === 'string' ? { message: opts } : (opts || {});
  return new Promise((resolve) => {
    if (!emit) { resolve(window.confirm(o.message || o.title || '确定？')); return; }
    emit({ ...o, resolve });
  });
}

// Wired by ConfirmHost on mount/unmount. Not for app code.
export function __setConfirmEmitter(fn) { emit = fn; }
